// extracted by mini-css-extract-plugin
module.exports = {"team":"style_team__yhh8y","teamLogo":"style_teamLogo__lExUB","name":"style_name__TEr0b"};